<template>
<!-- 通知对象公共组件 -->
  <div>
    <!-- 新增通知对象 -->
    <el-dropdown split-button type="primary"
      class="add_object_btn"
      @click="addObject"
    >
      {{ $t('device.add_notification_object') }}
      <el-dropdown-menu slot="dropdown" class="dropdown-div" placement="bottom">
        <el-button @click="addObject" class="dropdown-btn">{{ $t('selectMsg.Customize') }}</el-button>
        <el-dropdown-item v-for="(item, index) in objectList" :key="index" class="dropdown-item">
          <el-checkbox border v-model="item.checked" @change="handleSelect($event, item)">{{ item.name }}</el-checkbox>
          <i v-if="item.editable" class="el-icon-edit" @click="editObject(item)"></i>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>


    <div class="mt-5">
      <div v-for="(item, index) in selectObjectList" :key="index" class="items">
        <el-tooltip class="item-icon" effect="dark" :content="item.phone" placement="top-start">
          <i
            class="el-icon-chat-dot-round"
            :style="{color: item.smsOpen ? '#F59A23' : '#aaa'}">
          </i>
        </el-tooltip>
        <el-tooltip class="item-icon" effect="dark" :content="item.email" placement="top-start">
          <i
            class="el-icon-message"
            :style="{color: item.emailOpen ? '#F59A23' : '#aaa'}">
          </i>
        </el-tooltip>
        <span class="item-name">{{ item.name }}</span>
        <i class="el-icon-circle-close item-icon" style="color: red;"
          :title="$t('public.btn_delete')"
          @click="delObject(item)">
        </i>
      </div>
    </div>

    <!-- 新增通知对象模态框 -->
    <modal :title="$t('device.add_notification_object')" :visible.sync="isShowObject" width="400px" append-to-body>
      <el-form ref="objectForm" label-width="100px" :model="objectForm" :rules="objectRules" >
        <el-form-item :label="$t('device.notice') + $t('public.table_name')" prop="name">
          <el-input v-model.trim="objectForm.name" style="width: 250px" maxlength="50"/>
        </el-form-item>
         <el-form-item :label="$t('public.phone_num')" prop="phone">
          <el-input v-model.trim="objectForm.phone" style="width: 250px" maxlength="50"/>
        </el-form-item>
        <el-form-item :label="$t('public.emailbox')" prop="email">
          <el-input v-model.trim="objectForm.email" style="width: 250px" maxlength="50"/>
        </el-form-item>
        <el-form-item  class="icon_btns">
          <el-tooltip class="item-icon" effect="dark" :content="$t('integration.sms_notification')" placement="bottom">
            <i
              class="el-icon-chat-dot-round cursor-pointer"
              :style="{color: objectForm.smsOpen ? '#F59A23' : '#aaa'}"
              @click="clickType('sms')">
            </i>
          </el-tooltip>
          <el-tooltip class="item-icon" effect="dark" :content="$t('integration.email_notification')" placement="bottom">
            <i
              class="el-icon-message cursor-pointer"
              :style="{color: objectForm.emailOpen ? '#F59A23' : '#aaa'}"
              @click="clickType('email')">
            </i>
          </el-tooltip>
          <el-tooltip class="item-icon" effect="dark" :content="$t('user.btn_sync_contact')" placement="bottom">
            <i
              class="el-icon-user cursor-pointer"
              :style="{color: objectForm.isSyn ? '#F59A23' : '#aaa'}"
              @click="clickType('sync')">
            </i>
          </el-tooltip>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="isShowObject = false">{{ $t('public.btn_cancel') }}</el-button>
        <el-button type="primary" @click="handleSaveObject">{{ $t('public.btn_new') }}</el-button>
      </div>
    </modal>

  </div>
</template>

<script>
import { carrierNoticeSave, carrierNoticeSaveBatch, getCarrierNotice } from '@/api/modules/carrier'
import { accountList } from '@/api/modules/userInfo.js'
import { contactsList } from '@/api/modules/contact.js'
import { mapGetters } from 'vuex';


export default {
  name: 'NoticeObject',
  data() {
    return {
      selectObjectList: [], // 已选择的通知对象
      isShowObject: false,
      objectForm: {
        name: null,
        email: null,
        phone: null,
        smsOpen: 0,
        emailOpen: 0,
        phoneOpen: 0,
        isSyn: 0
      },
      objectList: [],
      objectRules: {
        name: [
          { required: true, message: this.$t('placeholderText.TypeInYourName'), trigger: 'blur' }
        ],
        email: [
          { required: true, message: this.$t('placeholderText.EnterYourEmail'), trigger: 'blur' },
          {
            validator: this.$fromRules.FormValidate.Form().Email,
            trigger: 'blur'
          }
        ],
        phone: [
          { required: true, message: this.$t('placeholderText.EnterPhoneNumber'), trigger: 'blur' },

        ],

      },
      isEdit: false,
    }
  },
  computed: {
     ...mapGetters(['userInfo']),
     sceneId(){
       return this.userInfo.scope.sceneId
     }

  },
  mounted(){
    this.getUser()
  },
  beforeDestroy(){
    this.selectObjectList = []
  },
  methods: {
    setNoticeList(list){
      if(list.length){
        list.forEach((item, index) => {
          let wayArr = item.way.split('')
          item.smsOpen = parseInt(wayArr[0])
          item.emailOpen = parseInt(wayArr[1])
          item.phoneOpen = parseInt(wayArr[2])
          item.isSyn = 0
          item.id = Date.now() + index
       })
        this.selectObjectList = list
      }else{
        this.selectObjectList = []
      }
    },
    // 新增通知对象
    addObject(){
      this.objectForm = {
        name: null,
        email: null,
        phone: null,
        smsOpen: 0,
        emailOpen: 0,
        phoneOpen: 0,
        isSyn: 0
      }
      this.isShowObject = true
      this.isEdit = false
    },
    // 保存新增通知对象
    handleSaveObject(){
      this.$refs.objectForm.validate(valid => {
        if(valid){
          let checkList = [...this.objectList]
          let index = 0
          if(this.isEdit){
            index = this.objectList.findIndex(_ => _.id === this.objectForm.id)
            checkList.splice(index, 1)
          }
          // 判断用户名、手机号、邮箱的唯一性
          if(checkList.findIndex(_ => _.name === this.objectForm.name) !== -1 ){
            this.$message.error($t('integration.name_already_exists'))
            return
          }
          if(checkList.findIndex(_ => _.phone === this.objectForm.phone) !== -1 ){
            this.$message.error($t('integration.mobile_number_already_exists'))
            return
          }
          if(checkList.findIndex(_ => _.email === this.objectForm.email) !== -1 ){
            this.$message.error($t('integration.mailbox_already_exists'))
            return
          }
          if(this.isEdit){
             this.objectList[index] = { ...this.objectForm}
            //如果已经选择了当前对象，this.selectObjectList也要更新
            let index2 = this.selectObjectList.findIndex(_ => _.id === this.objectForm.id)
            if(index2 !== -1){
               this.selectObjectList[index2] = { ...this.objectForm}
            }
          }else{
            this.objectList.push({
                ...this.objectForm,
                id: Date.now(),
                // 当前新增可编辑
                editable: true
              })
          }
          this.isShowObject = false
        }
      })
    },
    handleSelect(e, item){
      console.log('e==',e)
      if(e){
        this.$set(item, 'checked', true)
        this.selectObjectList.push(item)
      }else{
        this.$set(item, 'checked', false)
        let index = this.selectObjectList.findIndex(_ => _.id === item.id)
        this.selectObjectList.splice(index, 1)
      }
      console.log('selectObjectList=', this.selectObjectList)

    },
    clickType(type){
      switch(type) {
        case 'sms':

          this.objectForm.smsOpen = this.objectForm.smsOpen ? 0 : 1
          break
        case 'email':
          this.objectForm.emailOpen = this.objectForm.emailOpen ? 0 : 1
          break
        case 'phone':
          this.objectForm.phoneOpen = !this.objectForm.phoneOpen ? 0 : 1
          break
        case 'sync':
          if(this.objectForm.isSyn){
            this.objectForm.isSyn = 0
          }else{
            this.objectForm.isSyn = 1
          }
          break
      }
      this.$forceUpdate()
    },
    delObject(item){
      let index = this.selectObjectList.findIndex(_ => _.id === item.id)
      this.selectObjectList.splice(index, 1)
      let index2 = this.objectList.findIndex(_ => _.id === item.id)
      if(index2 !== -1){
        this.$set( this.objectList[index2], 'checked', false)
      }
    },
    // 获取对应客户下的用户
    getUser(){
      contactsList({
        sceneId: this.sceneId
      }).then(({result}) => {
          let list = result.map(row => {
            row.smsOpen = 1
            row.emailOpen = 1
            row.phoneOpen = 0
            row.isSyn = 0
            return row
          })
        this.objectList = list
      })
    },
    // 针对当前新增的通知对象的编辑功能
    editObject(item){
      this.isShowObject = true
      this.objectForm = { ...item }
      this.isEdit = true
    }
  }
}
</script>

<style lang="scss" scoped>
.add_object_btn {
  ::v-deep i {
    color: #FFFFFF !important;
  }
}
.dropdown-btn {
  width: 100%;
  margin: 2px 0;
}
.dropdown-item {
  margin: 2px 0;
  display: flex;
  align-items: center;
  .el-checkbox {
    width: 95%;
  }
}
.dropdown-div {
  height: 300px;
  overflow: auto;
  // overflow: hidden;
}
.icon_btns {
  i {
    margin: 0 5px;
    font-size: 20px;
    &:last-child {
      float: right;
    }
  }
}
.items {
  display: flex;
  margin-bottom: 8px;
  .item-icon {
    padding: 5px;
    border: 1px solid #CCCCCC;
    font-size: 18px;
  }
  .item-name {
    width: 360px;
    background-color: var(--primary-color);
    text-align: center;
    color: #FFFFFF;
  }
}

</style>
